// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stroke-label-editor {
  position: fixed;
  inset: 0;
  z-index: 12060;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  pointer-events: none;
}

.stroke-label-editor__backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(2, 6, 23, 0.28);
  pointer-events: auto;
}

.stroke-label-editor__sheet {
  position: relative;
  pointer-events: auto;
  width: min(560px, 100%);
  max-height: min(62vh, 520px);
  overflow: auto;
  margin: 0 10px max(10px, env(safe-area-inset-bottom, 0px));
  padding: 14px 14px 12px;
  border-radius: 18px;
  background: rgba(15, 23, 42, 0.94);
  color: #f8fafc;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(16px);
}

.stroke-label-editor__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.stroke-label-editor__kicker {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.stroke-label-editor__time {
  margin: 2px 0 0;
  font-variant-numeric: tabular-nums;
  font-size: 20px;
  font-weight: 700;
}

.stroke-label-editor__stroke-duration {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 650;
  opacity: 0.8;
}

.stroke-label-editor__icon-btn,
.stroke-label-editor__actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: inherit;
  border-radius: 12px;
  cursor: pointer;
}

.stroke-label-editor__icon-btn {
  width: 36px;
  height: 36px;
}

.stroke-label-editor__row,
.stroke-label-editor__phases,
.stroke-label-editor__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.stroke-label-editor__chip,
.stroke-label-editor__phase {
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: transparent;
  color: inherit;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.stroke-label-editor__chip--on {
  background: #e2e8f0;
  color: #0f172a;
  border-color: #e2e8f0;
}

.stroke-label-editor__phase--on {
  border-color: #f8fafc;
}

.stroke-label-editor__phase--set {
  background: rgba(226, 232, 240, 0.16);
}

.stroke-label-editor__phase--on.stroke-label-editor__phase--set,
.stroke-label-editor__phase--on {
  background: #e2e8f0;
  color: #0f172a;
}

.stroke-label-editor__phase {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  min-width: 108px;
}

.stroke-label-editor__phase-time,
.stroke-label-editor__phase-duration {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.72;
  font-variant-numeric: tabular-nums;
}

.stroke-label-editor__stamper {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
}

.stroke-label-editor__stamper button {
  min-height: 32px;
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.stroke-label-editor__stamper-time {
  min-width: 72px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.stroke-label-editor__hint {
  margin: 0 0 8px;
  font-size: 12px;
  opacity: 0.75;
}

.stroke-label-editor__actions button {
  min-height: 36px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 700;
}

.stroke-label-editor__actions button:disabled {
  opacity: 0.4;
  cursor: default;
}

.stroke-label-editor__list {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stroke-label-editor__list-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  color: inherit;
  padding: 8px 10px;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
}

.stroke-label-editor__list-btn--on {
  outline: 1px solid rgba(226, 232, 240, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/components/StrokeLabelEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,0DAA0D;EAC1D,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".stroke-label-editor {\n  position: fixed;\n  inset: 0;\n  z-index: 12060;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.stroke-label-editor__backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(2, 6, 23, 0.28);\n  pointer-events: auto;\n}\n\n.stroke-label-editor__sheet {\n  position: relative;\n  pointer-events: auto;\n  width: min(560px, 100%);\n  max-height: min(62vh, 520px);\n  overflow: auto;\n  margin: 0 10px max(10px, env(safe-area-inset-bottom, 0px));\n  padding: 14px 14px 12px;\n  border-radius: 18px;\n  background: rgba(15, 23, 42, 0.94);\n  color: #f8fafc;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(16px);\n}\n\n.stroke-label-editor__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.stroke-label-editor__kicker {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.stroke-label-editor__time {\n  margin: 2px 0 0;\n  font-variant-numeric: tabular-nums;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.stroke-label-editor__stroke-duration {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 650;\n  opacity: 0.8;\n}\n\n.stroke-label-editor__icon-btn,\n.stroke-label-editor__actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.08);\n  color: inherit;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.stroke-label-editor__icon-btn {\n  width: 36px;\n  height: 36px;\n}\n\n.stroke-label-editor__row,\n.stroke-label-editor__phases,\n.stroke-label-editor__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.stroke-label-editor__chip,\n.stroke-label-editor__phase {\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: transparent;\n  color: inherit;\n  border-radius: 999px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.stroke-label-editor__chip--on {\n  background: #e2e8f0;\n  color: #0f172a;\n  border-color: #e2e8f0;\n}\n\n.stroke-label-editor__phase--on {\n  border-color: #f8fafc;\n}\n\n.stroke-label-editor__phase--set {\n  background: rgba(226, 232, 240, 0.16);\n}\n\n.stroke-label-editor__phase--on.stroke-label-editor__phase--set,\n.stroke-label-editor__phase--on {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.stroke-label-editor__phase {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 12px;\n  min-width: 108px;\n}\n\n.stroke-label-editor__phase-time,\n.stroke-label-editor__phase-duration {\n  font-size: 11px;\n  font-weight: 600;\n  opacity: 0.72;\n  font-variant-numeric: tabular-nums;\n}\n\n.stroke-label-editor__stamper {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.stroke-label-editor__stamper button {\n  min-height: 32px;\n  padding: 0 10px;\n  border: 0;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.stroke-label-editor__stamper-time {\n  min-width: 72px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.stroke-label-editor__hint {\n  margin: 0 0 8px;\n  font-size: 12px;\n  opacity: 0.75;\n}\n\n.stroke-label-editor__actions button {\n  min-height: 36px;\n  padding: 0 10px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.stroke-label-editor__actions button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.stroke-label-editor__list {\n  list-style: none;\n  margin: 4px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stroke-label-editor__list-btn {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  border: 0;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.06);\n  color: inherit;\n  padding: 8px 10px;\n  font-size: 12px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.stroke-label-editor__list-btn--on {\n  outline: 1px solid rgba(226, 232, 240, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
